import Rails from "@rails/ujs"

const handleConfirm = (message, element) => {
  const modalElement = document.getElementById('deleteConfirmationModal')
  if (!modalElement) return true // Fallback to default if modal missing

  const modal = new bootstrap.Modal(modalElement)
  const confirmBtn = document.getElementById('confirmDeleteButton')
  const messageEl = document.getElementById('confirmationMessage')

  if (messageEl) messageEl.innerText = message

  modal.show()

  return new Promise((resolve) => {
    const handleConfirmClick = () => {
      modal.hide()
      confirmBtn.removeEventListener('click', handleConfirmClick)
      resolve(true)
    }

    confirmBtn.addEventListener('click', handleConfirmClick)

    modalElement.addEventListener('hidden.bs.modal', () => {
      confirmBtn.removeEventListener('click', handleConfirmClick)
      resolve(false)
    }, { once: true })
  })
}

// Override Rails.confirm
Rails.confirm = (message, element) => {
  handleConfirm(message, element).then((confirmed) => {
    if (confirmed) {
      // Temporarily disable confirm to avoid infinite loop
      const originalConfirm = Rails.confirm
      Rails.confirm = () => true
      element.click()
      Rails.confirm = originalConfirm
    }
  })
  return false // Prevent immediate action
}
